












import * as R from 'ramda';
import Vue from 'vue';

import ProgressButton from './Progress/ProgressButton';

// Total four states
// 0: Nothing, 1: Loading, 2: Success, 3: Warn, 4: Success

const contextClasses = R.cond([
    [R.equals(1), R.always(['m-button-context--active'])],
    [R.equals(2), R.always(['m-button--meadow','m-button-save--success'])],
    [R.equals(3), R.always([])],
    [R.equals(4), R.always(['m-button--harley', 'm-button-save--error'])],
    [R.T, R.always([])]
]);

export default Vue.extend({
    components: {
        'progress-button': ProgressButton
    },

    props: {
        transition: {
            default: 3500
        },
        state: {
            default: 0
        },
        disabled: {
            default: false
        }
    },

    data() {
        return {
            timer: 0
        };
    },

    computed: {
        classes(): string[] {
            return contextClasses(this.state);
        }
    },

    watch: {
        state(newState) {
            clearTimeout(this.timer);

            if (newState === 2 || newState === 4) {
                // New state becomes old state
                this.timer = window.setTimeout(
                    () => this.$emit('state', { oldState: newState, newState: 0 }),
                    this.transition);
            }
        }
    },

    beforeDestroy() {
        clearTimeout(this.timer);
    }
});
